const ro = {
  questionPaperLibrary: "Biblioteca de teste",
  questionPaperLibraryDescription:
    "Spatiul tau de lucru dinamic pentru crearea intrebarilor individuale si proiectarea seturilor complete de intrebari.",
  assessmentLibrary: "Biblioteca de evaluari",
  assessmentLibraryDescription:
    "Gestioneaza programarile, invita participantii si urmareste rapoartele de performanta intr-un hub centralizat.",
  myAssessmentWidgetTitle: "Evaluarea mea",
  myPreferences: "Preferințele mele",
  assessmentsForYou: "Evaluari pentru tine",
  exploreAssessmentsAssignedToYou: "Exploreaza evaluarile atribuite tie",
  hitachiAcademy: "Academia Hitachi",
  essentialBusinessKnowledgeTestForYou:
    "Test esential de cunostinte de afaceri pentru tine",
  continuousLearningJourneyDescription:
    "Conceput pentru a te ajuta sa iti intelegi si sa iti consolidezi abilitatile de business pe parcursul invatarii continue",
  noActiveAssessmentsScheduledForYou:
    "Nu exista evaluari active programate pentru tine",
  upcoming: "Urmatoare",
  notAttempted: "Neincercat",
  myAssessmentCardDescription:
    "Aceasta evaluare iti masoara abilitatile tehnice, analitice si de rezolvare a problemelor ca parte a procesului de recrutare in campus al GlobalLogic.",
  totalDuration: "Durata totala",
  startTime: "Ora de incepere",
  questionAuthoring: "Creare intrebari",
  reviewQuestions: "Revizuieste intrebarile",
  bulkUploadHistory: "Istoric incarcare in masa",
  bulkActionHistory: "Istoric actiuni in masa",
  editQuestion: "Editeaza intrebare",
  inviteParticipants: "Invita participanti",
  externalUserBulkUploadHistory:
    "Istoric incarcare in masa utilizatori externi",
  assessmentSchedule: "Program evaluare",
  assessmentReport: "Raport evaluare",
  bulkHistory: "Istoric in masa",
  myUpload: "Incarcarea mea",
  bulkUpload: "Incarcare in masa",
  createQuestion: "Creeaza intrebare",
  bulkUploadQuestions: "Incarcare in masa a intrebarilor",
  filters: "Filtre",
  clear: "Sterge",
  searchByTitle: "Cauta dupa titlu",
  refresh: "Reimprospateaza",
  refreshing: "Se reimprospateaza",
  reviewQuestionPapers: "Revizuieste seturi de intrebari",
  myQuestionPapers: "Seturile mele de intrebari",
  viewQuestionBank: "Vezi banca de intrebari",
  createNew: "Creeaza nou",
  sortBy: "Sorteaza dupa",
  state: "Stare",
  reviewed: "Revizuit",
  reviewedTooltip:
    "Afiseaza seturile de intrebari care au fost revizuite si apoi publicate.",
  all: "Toate",
  draft: "Ciorna",
  published: "Publicat",
  inReview: "In revizuire",
  sentBack: "Trimis inapoi",
  readyToPublish: "Gata de publicare",
  draftDescription:
    "Crearea setului de intrebari este inca in curs si nu este disponibila inca pentru cursanti",
  publishedDescription: "Setul de intrebari este live si accesibil cursantilor",
  inReviewDescription:
    "Setul de intrebari este in revizuire si nu este inca aprobat",
  sentBackDescription: "Setul de intrebari a fost trimis inapoi pentru revizii",
  readyToPublishDescription: "Setul de intrebari este gata de publicare",
  createdAt: "Creat la",
  updatedAt: "Actualizat la",
  publishedAt: "Publicat la",
  descending: "Descrescator",
  ascending: "Crescator",
  yes: "Da",
  no: "Nu",
  success: "Succes",
  error: "Eroare",
  warning: "Avertisment",
  info: "Informații",
  noMatchingContentFound: "Nu a fost gasit continut potrivit",
  noQuestionPapersAvailableForReview:
    "Nu exista seturi de intrebari disponibile pentru revizuire",
  questionPaperNotYetCreated: "Setul de intrebari nu a fost inca creat",
  createQuestionPaperDescription:
    "Creeaza un set de intrebari pentru a evalua abilitatile si cunostintele cursantilor",
  createYourFirstQuestionPaper: "Creeaza primul tau set de intrebari",
  createQuestionPaperModalTitle: "Creeaza set de intrebari",
  questionsTab: "Întrebări",
  questionPaperSettingsTab: "Setări hârtie de întrebare",
  editQuestionPaper: "Editați documentul cu întrebări",
  save: "Salva",
  publish: "Publica",
  sendForReview: "Trimite pentru revizuire",
  sendingForReview: "Se trimite spre revizuire",
  publishing: "Publicare",
  clone: "Clonează",
  delete: "Şterge",
  view: "Vedere",
  edit: "Edita",
  close: "Aproape",
  create: "Crea",
  creating: "Crearea",
  confirm: "Confirma",
  cancel: "Anula",
  version: "Versiune",
  untitled: "Fără titlu",
  noVersion: "Nici o versiune",
  title: "Titlu",
  status: "Stare",
  action: "Acţiune",
  createdBy: "Creat de",
  createNewVersion: "+ Versiune nouă",
  createNewVersionTitle: "Creați o versiune nouă",
  deleteQuestionPaperPrompt:
    "Ești sigur că vrei să ștergi acest document cu întrebări?",
  deleteQuestionPaperWithTitlePrompt:
    "Doriți să ștergeți această lucrare cu întrebări intitulată „{{title}}”?",
  cloneQuestionPaperPrompt: "Doriți să clonați această lucrare cu întrebări?",
  publishQuestionPaperPrompt:
    "Sunteți sigur că doriți să publicați această lucrare cu întrebări?",
  sendForReviewQuestionPaperPrompt:
    "Ești sigur că vrei să trimiți această lucrare cu întrebări pentru revizuire?",
  successfullyDeletedQuestionPaper: "S-a șters cu succes foaia cu întrebări",
  successfullyMovedQuestionPaperToDraft:
    "S-a mutat cu succes foaia cu întrebări la schiță",
  successfullySavedQuestionPaperData:
    "Au fost salvate cu succes datele din formularul de întrebări",
  successfullyClonedQuestionPaper: "S-a clonat cu succes foaia cu întrebări",
  successfullyCreatedQuestionPaper: "A creat cu succes lucrarea cu întrebări",
  validationFailedWithFollowingErrors:
    "Validarea a eșuat cu următoarele erori:",
  failedStatusUpdateOf: "Actualizarea stării eșuate a:",
  savedWithFollowingWarnings: "Salvat cu următoarele avertismente:",
  reviewedAndPublished: "Revizuit și publicat",
  deleting: "Se șterge...",
  cloning: "Clonarea...",
  assessment: "Evaluare",
  public: "Public",
  private: "Privat",
  visibility: "Vizibilitate",
  questionType: "Tip de întrebare",
  selectQuestionTypeAndVisibility:
    "Selectați Tipul întrebării și Vizibilitatea",
  singleChoice: "Alegere unică",
  multipleChoice: "Alegere Multiplă",
  trueOrFalse: "Adevărat sau Fals",
  fillInTheBlanks: "Completați spațiile libere",
  codingQuestion: "Întrebare de codificare",
  subjectiveQuestion: "Întrebare subiectivă",
  speakingQuestion: "Întrebare vorbită",
  downloadTemplateEditAndReuploadQuestions:
    "Descărcați șablonul, editați și reîncărcați lista de întrebări",
  downloadExcelTemplateInstruction:
    "Descărcați șablonul Excel folosind butonul de mai jos.",
  addQuestionsToSheetInstruction:
    "Adăugați întrebările dvs. în fișă (instrucțiunile sunt incluse în interior).",
  uploadCompletedExcelInstruction:
    "Încărcați fișierul Excel completat pentru a importa în bloc întrebările.",
  uploading: "Se încarcă...",
  uploadQuestions: "Încărcați întrebări",
  completed: "Terminat",
  invalid: "Invalid",
  initiated: "Iniţiat",
  failed: "A eșuat",
  fileName: "Nume de fișier",
  templateType: "Tip șablon",
  uploadedAt: "Încărcat la",
  actions: "Acțiuni",
  mcqTemplate: "Șablon MCQ",
  fibTemplate: "Șablon FIB",
  monitorUploadExcelDescription:
    "Monitorizați fiecare fișier Excel încărcat, verificați câte întrebări au fost adăugate sau nu au reușit și vedeți detalii despre eroare dacă este necesar.",
  reset: "Resetați",
  showing: "Se arată",
  to: "la",
  of: "de",
  results: "rezultate",
  noExcelFound: "Nu s-a găsit Excel",
  cloneAssessmentConfirmation: "Confirmarea evaluării clonării",
  cloneAssessmentWithTitlePrompt:
    "Sunteți sigur că doriți să clonați această evaluare intitulată „{{title}}”?",
  successfullyClonedAssessment: "Evaluarea a fost clonată cu succes",
  newVersionContentPrompt:
    "Sunteți pe cale să creați o nouă versiune a acestui conținut. Orice modificări suplimentare vor fi salvate în această versiune. Doriți să continuați?",
  createVersionWithNumber: "Creați (V{{version}})",
  addYourComment: "Adaugă comentariul tău",
  maxLimitReached: "limita maximă atinsă",
  deleteContentPrompt: "Ești sigur că vrei să ștergi acest {{contentType}}?",
  deleteContentWithTitlePrompt:
    "Ești sigur că vrei să ștergi acest {{contentType}} intitulat „{{title}}”?",
  schedulePreview: "Programează previzualizarea",
  reschedule: "Reprogramați",
  cancelled: "Anulat",
  copyLink: "Copiați linkul",
  assessmentIsCancelled: "Evaluarea este anulată",
  deleteConfirmation: "Ștergeți confirmarea",
  cancelConfirmation: "Anulați confirmarea",
  deleteAssessmentPrompt:
    "Sunteți sigur că doriți să ștergeți această evaluare?",
  cancelAssessmentPrompt: "Ești sigur că vrei să anulezi această evaluare?",
  rescheduleAssessment: "Reprogramează evaluarea",
  customTermsAndConditions: "Termeni și condiții personalizate",
  viewTermsAndConditions: "Vezi T&C",
  scheduleNewAssessment: "Programați o nouă evaluare",
  selectQuestionPaper: "Selectați foaia de întrebări",
  createAssessment: "Creați o evaluare",
  failedToLoadData: "Nu s-au încărcat datele!",
  assessmentNotYetCreated: "Evaluarea nu a fost încă creată",
  createAssessmentDescription:
    "Creați o evaluare pentru a evalua abilitățile și cunoștințele cursanților",
  createYourFirstAssessment: "Creați-vă prima evaluare",
  failedToLoadSchedules: "Nu s-au încărcat programele",
  errors: "Erori:",
  basicInformation: "Informații de bază",
  assessmentName: "Numele evaluării",
  na: "NA",
  scheduleInstructions: "Instrucțiuni de programare",
  noInstructionsProvided: "Nu au fost furnizate instrucțiuni",
  accessCriteria: "Criterii de acces",
  searchTags: "Etichete de căutare",
  viewAttributes: "Vedeți atributele",
  termsAndConditions: "Termeni și condiții",
  enabled: "Activat",
  disabled: "Dezactivat",
  requireCandidatesToAcceptTerms:
    "Solicitați candidaților să accepte T&C înainte de a începe evaluarea",
  proctoringSettings: "Setări de supraveghere",
  enableVideoProctoring: "Activați Video Proctoring",
  maximumVideoViolationsAllowed: "Maximul încălcărilor video permise",
  enableBrowserProctoring: "Activați supravegherea browserului",
  maximumBrowserViolationsAllowed:
    "Maximul de încălcări ale browserului permis",
  displayViolationsToCandidates: "Afișați încălcările candidaților",
  actionWhenViolationLimitReached:
    "Acțiune atunci când limita de încălcare a fost atinsă",
  flagged: "Marcat",
  terminate: "Reziliere",
  stakeholdersAndFeedback: "Părți interesate și feedback",
  owner: "Proprietar",
  recruiter: "Recruter",
  allowCandidateFeedback: "Permite feedback-ul candidaților",
  enableCandidateFeedbackDescription:
    "Permiteți candidaților să trimită feedback după finalizarea evaluării",
  schedulingAndTimerSettings: "Setări de programare și cronometru",
  scheduleType: "Tipul de program",
  loginWindow: "Fereastra de autentificare",
  durationBased: "Bazat pe durată",
  deadline: "Termen limită",
  autoCompleteMode: "Modul de completare automată",
  startDateAndTime: "Data și ora de începere",
  loginWindowInMinutes: "Fereastra de conectare (în minute)",
  endDateAndTime: "Data și ora de încheiere",
  timerEnabled: "Temporizator activat",
  assessmentRules: "Reguli de evaluare",
  assessmentPattern: "Model de evaluare",
  resultVisibility: "Vizibilitatea rezultatelor",
  passPercentage: "Procentaj de promovare",
  maximumAttemptsAllowed: "Numărul maxim de încercări permise",
  unlimitedAttempts: "Încercări nelimitate",
  attempt: "încercare",
  attempts: "încercări",
  coolOffPeriodBetweenAttempts: "Perioada de răcire între încercări",
  questionDisplaySettings: "Setări de afișare a întrebărilor",
  showQuestionTitle: "Afișați titlul întrebării",
  showQuestionTitleDescription:
    "Afișați titlul întrebării deasupra fiecărei întrebări",
  showHint: "Afișați indiciu",
  showHintDescription:
    "Activați indicii pentru a ajuta candidatul în timpul evaluării",
  showExplanation: "Arată explicația",
  hintLoading: "Trebuie să așteptați înainte de a vedea un alt indiciu",
  allHintsShown: "Nu există indicii în așteptare",
  hideExplanation: "Ascunde explicația",
  showExplanationDescription:
    "Afișați explicații după fiecare întrebare trimisă",
  showQuestionMarks: "Afișați semnele de întrebare",
  showQuestionMarksDescription:
    "Afișați nota/valoarea punctajului pentru fiecare întrebare",
  showWatermark: "Afișează filigran",
  showWatermarkDescription:
    "Afișați e-mailul candidatului pentru fiecare întrebare sub formă de filigran",
  questionPaperPreview: "Previzualizarea hârtiei cu întrebări",
  questionPaperReview: "Revizuirea hârtiei cu întrebări",
  createSchedule: "Creați program",
  reviewerComments: "Comentariile recenzenților",
  reviewComments: "Comentarii de revizuire",
  sendBackQuestionPaperPrompt:
    "Ești sigur că vrei să trimiți înapoi această lucrare cu întrebări?",
  moveQuestionPaperToDraftPrompt:
    "Sunteți sigur că doriți să mutați această lucrare cu întrebări în schiță?",
  markQuestionPaperReadyToPublishPrompt:
    "Sunteți sigur că doriți să marcați această lucrare cu întrebări gata de publicare?",
  questionPaperStatusUpdatedSuccessfully:
    "Starea hârtiei cu întrebări a fost actualizată cu succes!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Noua versiune pentru lucrarea cu întrebări creată cu succes!",
  questionPaperClonedSuccessfully:
    "Documentul cu întrebări a fost clonat cu succes!",
  startAddingQuestionsPreview:
    "Începeți să adăugați întrebări pentru a o previzualiza aici",
  bulkInviteParticipants: "Invitați în bloc participanții",
  bulkInviteParticipantsDescription:
    "Invitați mai mulți participanți simultan, încărcând un fișier Excel pre-completat. Vă rugăm să utilizați șablonul furnizat pentru a asigura formatul corect.",
  maxParticipantsPerFileNote:
    "Maxim 200 de participanți per fișier. Intrările duplicate sau nevalide vor fi omise cu o eroare.",
  downloadTemplate: "Descărcați șablonul",
  creatingUser: "Se creează utilizator...",
  bulkInviteLabel: "Invitație în bloc",
  createAndInvite: "Creați și invitați",
  myUploads: "Încărcările mele",
  enterIndividualsForInvite:
    "Introduceți numele uneia sau mai multor persoane pe care doriți să le invitați pentru evaluare",
  searchPeopleByEmailOrName: "Caută persoane după e-mail sau nume",
  noResultsFound: "Nu s-au găsit rezultate",
  loading: "Încărcare..",
  or: "Sau",
  multipleEmailsInviteDescription:
    "Adăugați e-mailuri de mai mulți utilizatori, separate prin virgule, pentru a invita mai mulți utilizatori la evaluare",
  addCandidates: "Adăugați candidați",
  pleaseEnterValidNameOrEmail:
    "Vă rugăm să introduceți un nume sau o adresă de e-mail validă",
  pleaseEnterValidEmailAddress:
    "Vă rugăm să introduceți o adresă de email validă",
  someEmailsCouldNotBeAdded: "Unele adrese de e-mail nu au putut fi adăugate",
  checkInvalidEmailIds:
    "Verificați următoarele ID-uri de e-mail - par a fi nevalide:",
  failedToSendInvitesFollowingEmails:
    "Trimiterea invitațiilor la următoarele e-mailuri a eșuat:",
  successfullyInvitedMembers: "A fost invitat membru {{count}}",
  validationFailed: "Validarea a eșuat",
  excelUploadedSuccessfully: "Excel încărcat cu succes",
  invalidBulkNominationTemplate: "Șablon de nominalizare în bloc nevalid",
  actionCompletedWithWarnings:
    "Acțiune finalizată cu următoarele avertismente:",
  actionFailedWithErrors:
    "Acțiunea nu a putut fi finalizată și ieșită cu următoarele erori:",
  trackBulkOperationsAndResults:
    "Urmăriți toate operațiunile dvs. în vrac și rezultatele acestora",
  partiallySaved: "Salvat parțial",
  statusInitiatedDescription:
    "Solicitarea de actualizare a întrebărilor a fost trimisă și este în curs de procesare.",
  statusCompletedDescription:
    "Toate întrebările selectate au fost actualizate cu succes.",
  statusFailedDescription:
    "Niciuna dintre întrebările selectate nu a putut fi procesată cu succes.",
  statusPartiallySavedDescription:
    "Unele întrebări au fost salvate cu succes, în timp ce altele au întâmpinat probleme.",
  draftReadyToPublishToPublish: "Schiță/Gata de publicare -> Publicare",
  actionType: "Tip de acțiune",
  uploadedOn: "Încărcat pe",
  viewDetails: "Vedeți detalii",
  loadingRecords: "Se încarcă înregistrările...",
  noRecordsFound: "Nu au fost găsite înregistrări",
  recordsPerPage: "Înregistrări pe pagină:",
  page: "Pagină",
  untitledQuestion: "Întrebare fără titlu",
  globalLogic: "GlobalLogic",
  aiGenerated: "AI generat",
  fullScreen: "Ecran complet",
  exitFullScreen: "Ieșiți pe ecran complet",
  skills: "Abilități",
  tags: "Etichete",
  allowedCodingLanguages: "Limbi de codare permise",
  marks: "Marci",
  lastUpdatedAt: "Ultima actualizare la",
  solutionCode: "Cod soluție",
  solution: "Soluţie",
  starterCode: "Cod de pornire",
  options: "Opțiuni",
  explanation: "Explicaţie",
  hint: "Aluzie",
  deleteQuestion: "Șterge întrebarea",
  noSections: "Nicio secțiune adăugată",
  editAndPublish: "Editați și publicați",
  sendBackToDraftInstruction:
    "Faceți clic pe butonul de trimitere înapoi pentru a trimite întrebarea înapoi în schiță.",
  updateStatusReadyToPublishInstruction:
    "Faceți clic pe butonul Gata de publicare pentru a actualiza starea.",
  successfullyUpdatedStatus: "S-a actualizat cu succes starea",
  dismiss: "Respingeți",
  ongoing: "În desfășurare",
  toBeLaunched: "Urmează să fie lansat",
  contentExpired: "Conținut expirat",
  notApplicable: "Nu se aplică",
  expiresSoon: "Expiră în curând",
  contentCreationInProgressTooltip:
    "Crearea conținutului este încă în desfășurare și nu este încă disponibilă pentru cursanți",
  contentLiveAccessibleTooltip:
    "Conținutul este publicat și accesibil cursanților",
  contentAvailableWithinDatesTooltip:
    "Conținutul este disponibil în prezent, deoarece este în intervalul datelor de lansare și expirare",
  contentNotLaunchedAvailableOnTooltip:
    "Conținutul nu a fost lansat încă și va fi disponibil la",
  contentExpiredOnTooltip: "Acest conținut a expirat la",
  statusAvailableAfterPublishTooltip:
    "Starea va fi disponibilă după ce conținutul este publicat",
  contentExpiresWithin48HoursTooltip:
    "Conținutul va expira în următoarele 48 de ore.",
  moveToDraftOrCloneToEdit:
    "Mutați-l în ciornă sau clonați-l pentru a face modificări",
  webContent: "Conținut web",
  eLearning: "E-learning",
  untitledContent: "Conținut fără titlu",
  sendToDraft: "Trimite în ciornă",
  sendToDraftPublishedInstruction:
    "Acest conținut este deja publicat. Pentru a face modificări, faceți clic pe butonul Trimite în ciornă.",
  copyLinkForLearner: "Copiază linkul pentru cursant",
  questionPaperName: "Nume set întrebări",
  type: "Tip",
  duration: "Durată",
  minutes: "Minute",
  difficultyLevel: "Nivel de dificultate",
  language: "Limbă",
  timezone: "Fus orar",
  preferredLocation: "Locație preferată",
  notSelected: "Neselectat",
  selectedPreferencesHeading: "Preferințe selectate",
  selectedPreferencesInfo: "Preferințe selectate pentru o experiență fluidă",
  shortDescription: "Descriere scurtă",
  totalMarks: "Punctaj total",
  questionPaperInstructions: "Instrucțiuni set întrebări",
  expiryDate: "Data expirării",
  knowledgeCategory: "Categorie de cunoștințe",
  category: "Categorie",
  subCategory: "Subcategorie",
  region: "Regiune",
  usage: "Utilizare",
  internalUseOnly: "Doar pentru uz intern",
  externalUseOnly: "Doar pentru uz extern",
  availableForAll: "Disponibil pentru toti",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "America Latină",
  northAmerica: "America de Nord",
  globalRegion: "Global",
  automotive: "Auto",
  bankingFinancialServicesInsurance: "Bănci, servicii financiare și asigurări",
  connectivitySolutionsCommunication: "Soluții de conectivitate/comunicații",
  consumerRetail: "Consum și retail",
  healthcareLifeSciences: "Sănătate și științe ale vieții",
  manufacturingAndIndustrial: "Producție și industrie",
  mediaEntertainment: "Media și divertisment",
  technology: "Tehnologie",
  other: "Altul",
  behavioralInterpersonal: "Comportamental/Interpersonal",
  technical: "Tehnic",
  processAndTools: "Procese și instrumente",
  polishLanguage: "Poloneză",
  spanishLanguage: "Spaniolă",
  japaneseLanguage: "Japoneză",
  germanLanguage: "Germană",
  ukrainianLanguage: "Ucraineană",
  swedishLanguage: "Suedeză",
  romanianLanguage: "Română",
  slovakLanguage: "Slovacă",
  croatianLanguage: "Croată",
  englishUsLanguage: "Engleză (US)",
  englishUkLanguage: "Engleză (UK)",
  englishInLanguage: "Engleză (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Standarde și protocoale auto",
  businessAnalysis: "Analiză de business",
  cCpp: "C/C++",
  cloudDataScience: "Data science în cloud",
  bigData: "Big Data",
  dataAnalytics: "Analiză de date",
  databaseTech: "Bază de date",
  developmentTools: "Instrumente de dezvoltare",
  devops: "DevOps",
  embedded: "Sisteme embedded",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Nucleu Linux",
  mobileDev: "Dezvoltare mobilă",
  networking: "Rețelistică",
  operatingSystemsServers: "Sisteme de operare și servere",
  otherTech: "Altele - Tech",
  productivityTools: "Instrumente de productivitate",
  programmingLangOther: "Limbaj de programare - Altele",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Inginerie software",
  uxUi: "UX/UI",
  architectureTech: "Arhitectură",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Ingineria cerințelor/Redactare tehnică",
  onboarding: "Onboarding",
  glTools: "Instrumente GL",
  processAndPolicies: "Procese și politici",
  communicationSubCategory: "Comunicare",
  personalEffectiveness: "Eficiență personală",
  methodologies: "Metodologii",
  projectManagement: "Management de proiect",
  peopleManagement: "Managementul oamenilor",
  leadershipPrograms: "Programe de leadership",
  domain: "Domeniu",
  reviewer: "Evaluator",
  none: "Niciunul",
  questionPaperPreviewBreadcrumb: "Previzualizare set întrebări: {{title}}",
  questionPaperInReviewContactReviewer:
    "Acest set de întrebări este în prezent în revizuire. Vă rugăm să contactați evaluatorul.",
  randomization: "Randomizare",
  randomizationInSectionDescription:
    "Intrebarile din aceasta sectiune vor fi afisate candidatilor intr-o ordine aleatorie",
  questionPreviewPlaceholderImage:
    "Substitut pentru previzualizarea întrebării",
  createNewVersionPromptWithNumber: "Creați o versiune nouă (V{{version}})?",
  questionPreviewBreadcrumb: "Previzualizare intrebare: {{title}}",
  questionPreviewTitle: "Previzualizare intrebare",
  adminView: "Vizualizare administrator",
  candidateView: "Vizualizare candidat",
  viewAsCandidate: "Vizualizeaza ca candidat",
  closePanel: "Inchide panoul",
  internalQuestion: "Intrebare interna",
  expiresOn: "Expira la",
  expiredLabel: "Expirat",
  solutionNotAdded: "Solutia nu a fost adaugata",
  testCases: "Cazuri de test",
  testCasesNotAdded: "Cazurile de test nu au fost adaugate",
  starterCodeNotAdded: "Codul de pornire nu a fost adaugat",
  groupTitleLengthValidation:
    "Titlul grupului trebuie sa aiba peste 5 si sub 120 de caractere",
  addTitleHere: "Adauga titlul aici...",
  groupUpdatedSuccessfully: "Grup actualizat cu succes",
  groupDeletedSuccessfully: "Grup sters cu succes",
  group: "Grup",
  numberOfQuestionsToBeShown: "Numarul de intrebari care vor fi afisate",
  questionLimitPerSectionDescription:
    "Afisati candidatilor doar un anumit numar de intrebari in sectiuni",
  numberOfQuestionsToShow:
    "Numarul de intrebari de afisat {{picked}}/{{total}}",
  collapseGroup: "Restrange grupul",
  expandGroup: "Extinde grupul",
  groupSetupStartAddingQuestions:
    "Un grup este configurat pentru aceasta sectiune. Incepeti sa adaugati intrebari.",
  addMoreQuestions: "Adauga mai multe intrebari",
  addQuestionFromLibrary: "Adauga intrebare din biblioteca",
  questionDeletedSuccessfully: "Intrebarea a fost stearsa cu succes",
  questionsShownCountUpdated: "Numarul de intrebari afisate a fost actualizat",
  failedToDeleteQuestion: "Stergerea intrebarii a esuat",
  caseSensitive: "Sensibil la majuscule/minuscule",
  caseSensitiveDescription:
    "Daca este activat, cursantii trebuie sa introduca raspunsul cu exact aceleasi litere mari si mici.",
  enterYourAnswerBelow: "Introduceti raspunsul mai jos",
  caseSensitiveAnswerInfo:
    "Aceasta intrebare este sensibila la majuscule/minuscule, asa ca introduceti raspunsurile cu literele mari si mici exacte.",
  answerWithNumber: "Raspuns {{number}}",
  inviteEmailsPlaceholder: "user1@globallogic.com, user2@globallogic.com",
  visibleTestCases: "Cazuri de test vizibile",
  hiddenTestCases: "Cazuri de test ascunse",
  visibleLabel: "Vizibil",
  hiddenLabel: "Ascuns",
  responseSetting: "Setari raspuns",
  recordingLimit: "Limita de inregistrare",
  minimumResponseDuration: "Durata minima a raspunsului",
  uploadLimit: "Limita de incarcare",
  practiceAllowed: "Practica permisa",
  standardEvaluationRubricInfo:
    "Aceasta este rubrica standard de evaluare care va fi folosita pentru a evalua raspunsul candidatului la aceasta intrebare.",
  criteria: "Criterii",
  weightPercentage: "Pondere(%)",
  viewRemarks: "Vezi observații",
  input: "Intrare",
  expectedOutput: "Ieșire așteptată",
  actualOutput: "Ieșire reală",
  untitledSection: "Secțiune fără titlu",
  testSectionDescription: "Descrierea secțiunii de test",
  groupAddedSuccessfully: "Grup adăugat cu succes",
  addGroupToSection: "Adăugați grup la secțiune",
  deleteSection: "Ștergeți secțiunea",
  questionPaperDetails: "Detalii foaie de întrebări",
  skillsInfoMessage:
    "Enumerați competențele cheie pe care această foaie de întrebări intenționează să le evalueze.",
  contentSettings: "Setări conținut",
  stakeholderAndReview: "Stakeholdeți și revizuire",
  statusType: "Tip de stare",
  notReviewed: "Nerevizuit",
  sourceType: "Tip sursă",
  proficiency: "Competență",
  beginner: "Începător",
  intermediate: "Intermediar",
  advanced: "Avansat",
  wecp: "WECP",
  enterMarks: "Introduceți marcaje",
  removeSkill: "Eliminați îndemânarea",
  searchSkills: "Abilități de căutare",
  noSkillsFound: "Nu s-au găsit abilități.",
  enterTag: "Introduceți o etichetă",
  enterOwner: "Introduceți proprietarul",
  enterReviewer: "Introduceți recenzentul",
  noUserWithRole: "Niciun utilizator cu acest rol nu a fost găsit",
  createSection: "Creează secțiune",
  untitledGroup: "Grup fără titlu",
  createGroup: "Creare grup",
  collapseSections: "Restrânge secțiunile",
  expandSections: "Extinde secțiunile",
  assessmentNamePlaceholder: "Vă rugăm să introduceți numele evaluării",
  questionPaperTitleInfo:
    "Introduceți un titlu clar, descriptiv pentru lucrarea cu întrebări.",
  shortDescriptionPlaceholder: "Furnizați o scurtă descriere",
  shortDescriptionInfo:
    "Un scurt rezumat care explică ce acoperă lucrarea cu întrebări.",
  questionPaperInstructionsInfo:
    "Scrieți instrucțiunile pe care le vor vedea candidații înainte de a începe lucrarea cu întrebări. Includeți detalii importante, cum ar fi regulile secțiunilor, formatele de întrebări, sfaturi de navigare și instrucțiuni de trimitere.",
  questionPaperInstructionsPlaceholder:
    "Adăugați orice instrucțiuni importante pentru cursanți înainte de a începe evaluarea - durată, criterii de promovare, instrumente permise sau ghiduri.",
  totalMarksAutoCalculatedInfo:
    "Notele totale vor fi calculate automat pe baza numărului de întrebări selectate pentru fiecare grup. Dacă numărul de întrebări de afișat este setat la 0, grupul respectiv va fi exclus din punctajul total.",
  questionPaperType: "Tip hârtie de întrebare",
  questionPaperTypeInfo: "Selectați formatul hârtiei cu întrebări.",
  durationInfo:
    "Stabiliți timpul limită total pentru completarea întrebării (în minute).",
  difficultyLevelInfo:
    "Selectați nivelul de dificultate așteptat pe baza experienței candidatului.",
  languageInfo: "Alegeți limba în care va fi prezentată lucrarea cu întrebări.",
  tagsInfo:
    "Adăugați cuvinte cheie pentru a-i ajuta pe alții să găsească această lucrare cu întrebări printr-o căutare.",
  selectCategory: "Selectați Categorie",
  createLevel: "Crea",
  evaluate: "Evalua",
  analyze: "Analiza",
  apply: "Aplicați",
  understand: "Înţelege",
  remember: "Ține minte",
  allowedCodingLanguagesRequiredInfo:
    "câmpul este obligatoriu numai atunci când adăugați întrebări de codificare la foaia cu întrebări.",
  knowledgeCategoryInfo:
    "Selectați nivelul de abilități cognitive vizat de această lucrare de întrebare, de exemplu, Amintiți-vă, Înțelegeți, Aplicați.",
  allowedCodingLanguagesInfo:
    "Selectați limbajele de programare permise pentru codificarea întrebărilor din această lucrare de întrebări.",
  expiryDateInfo:
    "Setați o dată opțională după care această lucrare cu întrebări să nu mai fie utilizată.",
  visibilityInfo: "Selectați vizibilitatea hârtiei cu întrebări",
  visibilityLockedInfo:
    "Odată ce o lucrare cu întrebări este publicată cu vizibilitate publică, toate celelalte versiuni ale sale vor avea și vizibilitate publică. În mod similar, dacă este publicat ca privat, toate versiunile vor rămâne private.",
  reviewRequired: "Revizuirea necesară",
  reviewRequiredLockedInfo:
    "Setarea „Revizuire obligatorie” este sincronizată în toate versiunile unui Document de întrebări. Dacă orice versiune este publicată cu revizuirea activată sau dezactivată, aceeași setare se va aplica tuturor versiunilor și nu poate fi editată individual.",
  reviewRequiredInfo:
    "Activați dacă această lucrare cu întrebări trebuie să treacă printr-un proces formal de revizuire înainte de publicare.",
  savingData: "Se salvează datele...",
  questionDataSavedSuccessfully:
    "Datele întrebărilor au fost salvate cu succes",
  sendQuestionForReviewInstruction:
    "Faceți clic pe butonul Trimitere pentru revizuire pentru a-l trimite recenzentului pentru a-l examina!",
  publishQuestionInstruction:
    "Faceți clic pe butonul Publicare pentru a publica întrebarea.",
  noLearningContentAddedAfterSelectingYes:
    "Nu a fost adăugat conținut de învățare după ce ați selectat Da",
  expectedTimeInMinutes: "Timp estimat (în min)",
  codingMarksAutoCalculatedInfo:
    "Acest punctaj este calculat automat pe baza cazurilor de testare ascunse adăugate la această întrebare",
  skillsInfoMessageQuestion:
    "Furnizați abilități specifice pe care participanții le vor dobândi din întrebare",
  skillsSubtitleQuestion: "Setați abilitățile asociate cu această întrebare",
  allowedCodingLanguagesInfoQuestion:
    "Alegeți limbile disponibile pentru rezolvarea acestei întrebări",
  selectCodingLanguages: "Selectați limbile de codare",
  allLanguages: "Toate Limbile",
  tagsInfoQuestion:
    "Furnizați cuvinte cheie pentru a clasifica, descrie și identifica evenimentul",
  tagsSubtitleQuestion: "Setați etichetele pentru căutare rapidă",
  knowledgeCategorySubtitleQuestion:
    "Ajută la clasificarea întrebărilor în funcție de nivelul de abilități cognitive.",
  explanationNotAvailableForSpeakingQuestion:
    "Explicația nu este disponibilă pentru întrebarea vorbită",
  ownerVersionSyncInfo:
    "Dacă schimbăm proprietarul acestei versiuni, se va actualiza și în toate versiunile create.",
  ownerInfoMessage: "Selectați proprietarii primari ai întrebării",
  ownerReviewerCannotBeSame: "proprietarul și recenzentul nu pot fi la fel",
  reviewerInfoMessage:
    "Selectați o persoană sau un grup de persoane ca evaluator(i)",
  stakeholdersUpdatedSuccessfully:
    "Părțile interesate au fost actualizate cu succes!",
  unexpectedErrorCreatingNewVersion:
    "A apărut o eroare neașteptată la crearea unei noi versiuni.",
  previewAndPublish: "Previzualizați și publicați",
  viewAnalytics: "Vedeți Analytics",
  cloneQuestionPrompt: "Doriți să clonați această întrebare?",
  evaluationRubric: "Rubrica de evaluare",
  problemStatement: "Declarație de problemă",
  problemStatementPlaceholder:
    "Introduceți Declarația de problemă sau Declarația pentru test",
  addOptionsAndMarkCorrectAnswer:
    "Adaugă opțiuni și marchează răspunsul corect",
  markCorrectAnswer: "Marcați răspunsul corect",
  addCorrectAnswer: "Adăugați răspunsul corect",
  enterCorrectAnswerForBlank:
    "Introduceți răspunsul corect pentru {{number}} necompletat",
  blankWithNumber: "{{number}} necompletat",
  addProblemStatementWithBlankToEnableAnswer:
    "Adăugați o declarație de problemă corectă cu „&blank” pentru a activa răspunsul.",
  enterSolution: "Introduceți soluția",
  enterExplanation: "Introduceți explicația",
  codingSolutionExplanationPlaceholder:
    "Explicați pe scurt logica, abordarea și cazurile marginale tratate în soluția optimă",
  optionWithNumber: "Opțiunea {{number}}",
  enterExplanationForAnswer:
    "Introduceți explicația pentru răspunsul {{number}}",
  addOptionToEnableExplanation:
    "Adăugați opțiunea {{number}} pentru a activa explicația.",
  enterExplanationForBlank:
    "Introduceți explicația pentru {{number}} necompletat",
  addProblemStatementWithBlankToEnableExplanation:
    "Adăugați o declarație corectă a problemei cu „&blank” pentru a activa explicația.",
  enterHint: "Introduceți indiciu",
  addUpTo3Hints: "Adaugă până la 3 indicii",
  addMoreOptions: "Adăugați mai multe opțiuni",
  answer: "Răspuns",
  exitCodeBlockInfo:
    "Pentru a ieși din blocul de cod, mergeți la sfârșitul rândului și faceți clic pe „Enter” de trei ori",
  fibBlankInsertionInfo:
    "Pentru a adăuga un spațiu necompletat, selectați text și faceți clic pe butonul „Inserare necompletat” sau adăugați manual &blankN, unde N poate fi orice număr întreg, de exemplu: &blank1;",
  htmlEditorAccessInfo:
    "Pentru a adăuga cod sau a avea control asupra formatului, puteți accesa editorul HTML făcând clic pe pictograma de editare",
  skillSelectionCannotBeEmpty: "Selectarea aptitudinilor nu poate fi goală",
  maxDurationInfo:
    "Timpul maxim permis unui utilizator pentru a-și înregistra răspunsul la această întrebare.",
  minDurationInfo:
    "Timpul minim necesar de înregistrare pe care un utilizator trebuie să îl finalizeze înainte de a-și trimite răspunsul.",
  uploadLimitInfo:
    "De câte ori un utilizator își poate reînregistra răspunsul înainte de trimiterea finală.",
  textQuestionTitle: "Aceasta este o întrebare text",
  audioRecordQuestionTitle:
    "Aceasta este o întrebare privind înregistrarea audio",
  audioUploadQuestionTitle: "Aceasta este o întrebare de încărcare audio",
  videoRecordQuestionTitle:
    "Aceasta este o întrebare privind înregistrarea video",
  videoUploadQuestionTitle: "Aceasta este o întrebare de încărcare video",
  subjectiveQuestionUploadConfigTitle:
    "Întrebare subiectivă Încărcare Config Titlu",
  recordingLimitInMinutes: "Limită de înregistrare (în min.)",
  minimumResponseDurationInMinutes: "Durata minimă a răspunsului (în min.)",
  recordingLimitLessThanTwenty:
    "Limita de înregistrare trebuie să fie mai mică de 20",
  recordingLimitGreaterThanOrEqualOne:
    "Limita de înregistrare trebuie să fie mai mare sau egală cu 1",
  minimumDurationLessThanRecordingLimit:
    "Durata minimă de răspuns trebuie să fie mai mică decât Limita de înregistrare",
  durationGreaterThanPointFive: "Durata trebuie să fie mai mare de 0,5",
  uploadLimitGreaterThanZero:
    "Limita de încărcare trebuie să fie mai mare de 0",
  addFieldSelectCodingLanguagesInfo:
    "Pentru a adăuga un {{fieldLabel}}, selectați mai întâi limbile de codare permise în secțiunea „{{basicDetails}}”.",
  basicDetails: "Detalii de bază",
  loadingEditor: "Se încarcă editorul...",
  run: "Execută",
  writingSolutionInLanguage: "În prezent scrieți o soluție în",
  changingToLanguageWillClearInput: "Schimbarea în",
  unsavedChangesWillBeLostInLanguage: "Modificările dvs. nesalvate în",
  changeLanguage: "Schimbați limba",
  testCase: "Caz de testare",
  add: "Adăuga",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Adăugați minimum 2 cazuri de testare vizibile și 3 cazuri de testare ascunse în mai jos",
  visibleToCandidatesForSelfEvaluation:
    "Vizibil pentru candidați pentru autoevaluare",
  noVisibleTestCasesAddedYet:
    "Nu s-au adăugat încă cazuri de testare vizibile. Faceți clic pe butonul de mai jos pentru a adăuga unul.",
  visibleTestCasesCannotExceedTwenty:
    "Cazurile de testare vizibile nu pot depăși 20",
  addMoreVisibleTestCases: "Adăugați mai multe cazuri de testare vizibile",
  maximumTestCasesLimitReached:
    "Limita maximă de cazuri de testare a fost atinsă",
  hiddenToCandidatesRunsAfterSubmit:
    "Ascuns pentru candidați, rulează după depunerea candidatului",
  noHiddenTestCasesAddedYet:
    "Nu s-au adăugat încă cazuri de testare ascunse. Faceți clic pe butonul de mai jos pentru a adăuga unul.",
  hiddenTestCasesCannotExceedTen:
    "Cazurile de testare ascunse nu pot depăși 10",
  addMoreHiddenTestCases: "Adăugați mai multe cazuri de testare ascunse",
  hiddenTestCase: "Caz de testare ascuns",
  visibleTestCase: "Caz de testare vizibil",
  someQuestionsCouldNotBeUpdated:
    "Unele întrebări nu au putut fi actualizate. Vă rugăm să examinați întrebările și să încercați din nou.",
  publishSummary: "Publicați rezumatul",
  sendForReviewSummary: "Trimiteți rezumatul pentru revizuire",
  moveToDraftSummary: "Treceți la rezumatul schiță",
  actionSummary: "Rezumatul acțiunilor",
  publishSummarySubtitle:
    "Iată rezumatul acțiunii dvs. de publicare. Consultați detaliile de mai jos.",
  sendForReviewSummarySubtitle:
    "Iată rezumatul solicitării dvs. de revizuire. Consultați detaliile de mai jos.",
  moveToDraftSummarySubtitle:
    "Iată rezumatul trecerii dvs. la proiectul de acțiune. Consultați detaliile de mai jos.",
  actionSummarySubtitle:
    "Iată rezumatul acțiunii tale. Consultați detaliile de mai jos.",
  successfully: "Cu succes",
  failedTo: "Nu a reușit",
  moveToDraft: "Mutați la Schiță",
  details: "Detalii",
  questionTitle: "Titlul întrebării",
  reason: "Motiv",
  showLess: "Arată mai puțin",
  showMoreCount: "Afișați încă {{count}}",
  uploadedAllCountItems: "Au încărcat toate {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Încărcat parțial {{successCount}}/{{totalCount}} {{item}}",
  users: "utilizatorii",
  questions: "întrebări",
  viewErrors: "Vedeți erorile",
  errorsWithFileName: "Erori - {{fileName}}",
  inputIsRequired: "Este necesară introducerea",
  expectedOutputIsRequired: "Este necesară rezultatul așteptat",
  expectedOutputCannotBeBlank:
    "Rezultatele așteptate nu trebuie să fie goale sau doar spații",
  marksMustBeNumber: "Semnele ar trebui să fie un număr",
  marksAreRequired: "Sunt necesare mărci",
  hiddenTestCaseMarksGreaterThanZero:
    "Notele pentru cazurile de testare ascunse ar trebui să fie mai mari decât 0 pentru a continua.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Notele pentru cazurile de testare ascunse nu trebuie să depășească 30.000.",
  explanationMinFiveIfProvided:
    "Explicația trebuie să aibă cel puțin 5 caractere dacă este furnizată",
  explanationIsRequired: "Este necesară explicația",
  explanationMinFiveNotBlank:
    "Explicația trebuie să conțină cel puțin 5 caractere și nu doar spații",
  provideInput: "Furnizați intrare",
  provideExpectedOutput: "Furnizați rezultatul așteptat",
  enterScore: "Introdu scorul",
  optional: "opțional",
  explainTestCase: "Explicați cazul de testare",
  updateTestCase: "Actualizați cazul de testare",
  addTestCase: "Adăugați un caz de testare",
  deleteQuestionWithTitlePrompt:
    "Sigur doriți să ștergeți această întrebare intitulată '{{title}}'?",
  errorFetchingData: "Eroare la preluarea datelor",
  rowNumber: "Numărul rândului",
  columnName: "Numele coloanei",
  useCase: "Caz de utilizare",
  startsAt: "Începe la",
  endsAt: "Se termină la",
  invite: "Invita",
  viewReport: "Vizualizați raportul",
  successfullyDeletedAssessment: "Evaluarea a fost ștearsă",
  successfullyFreezeActionAssessment: "{{action}} evaluarea cu succes",
  freezeOperationFailed: "Operațiunea de înghețare a eșuat",
  deleteAssessmentWithTitlePrompt:
    "Sigur doriți să ștergeți această evaluare intitulată „{{title}}”?",
  freeze: "Îngheţa",
  unfreeze: "Dezghețați",
  freezeAssessmentPrompt: "Sigur doriți să {{action}} această evaluare?",
  expiresAt: "Expiră la",
  seePreview: "Consultați Previzualizare",
  schedule: "Programa",
  skillBenchmarking: "Analiza comparativă a competențelor",
  skillBenchmarkingOverview:
    "O privire de ansamblu asupra competenței participanților în abilități specifice.",
  proctoringAnalysis: "Analiza Proctoring",
  proctoringAnalysisOverview:
    "O privire de ansamblu rapidă a aspectelor evaluării legate de supraveghere.",
  proctoringStatus: "Starea de supraveghere",
  noIrregularitiesReported: "Nu au fost raportate nereguli.",
  monitoringOverview: "Prezentare generală a monitorizării",
  complianceNoIncidents:
    "Respectarea regulilor de evaluare; fără incidente sau comportamente semnalate.",
  viewEvidenceClicked: "Dovezi făcute clic!",
  marksObtained: "Mărcile Obținute",
  correctAnswer: "Răspuns corect",
  wrongAnswer: "Răspuns greșit",
  sectionWiseAnalysis: "Analiză în secțiune",
  sectionWiseAnalysisOverview:
    "O prezentare generală a fiecărei întrebări și răspunsul candidatului.",
  openAllSections: "Deschideți toate secțiunile",
  closeAllSections: "Închideți toate secțiunile",
  sectionWithNumber: "Secțiunea {{number}}:",
  score: "Scor",
  questionAnalysis: "Analiza întrebărilor",
  questionTitleFallback: "Titlul întrebării",
  candidateAnswer: "Răspunsul candidatului",
  loadAllQuestions: "Încarcă toate {{count}} {{item}}",
  attemptWithNumber: "Încercarea #{{number}}",
  invalidReportUrl: "Adresa URL a raportului nevalidă",
  failedToDownloadReportTryAgainLater:
    "Nu s-a putut descărca raportul. Vă rugăm să încercați din nou mai târziu!",
  downloadReport: "Descărcați raportul",
  participantName: "Numele participantului",
  dateOfAttempt: "Data tentativei",
  fail: "Eșuează",
  pass: "Pasa",
  userScoredInAssessment: "{{name}} a obținut {{percentage}} la evaluare.",
  overallSummary: "Rezumat general",
  sectionAnalytics: "Secțiunea Analytics",
  allAttempts: "Toate încercările",
  bestAttempt: "Cea mai bună încercare",
  latestAttempt: "Ultima încercare",
  participantList: "Lista participanților",
  totalParticipantsInvited: "Total participanți invitați",
  notStarted: "Nu a început",
  inProgress: "În curs",
  resultsInProgress: "Rezultate în curs",
  searchByNameOrEmail: "Căutați după nume sau e-mail",
  noUsersAvailableReportCannotBeGenerated:
    "Nu există utilizatori disponibile - raportul nu poate fi generat.",
  userName: "Nume de utilizator",
  totalAttempt: "Încercare totală",
  percentage: "Procent(%)",
  attemptTimeline: "Cronologie de încercare",
  noDataFound: "Nu s-au găsit date",
  outOfMarks: "{{obtained}} din {{max}} puncte",
  resultInProcess: "Rezultat în proces",
  participantNotFound: "Participantul nu a fost găsit!",
  searchedParticipantNotFound: "Participantul căutat nu a fost găsit!",
  noParticipantEnrolled: "Nu există participanți înscriși!",
  noDataToDisplay: "Nu există date de afișat",
  participantsPerPage: "Participanți pe pagină:",
  actionFailed: "Acțiunea eșuată",
  failedToRemoveUser: "Nu s-a putut elimina utilizatorul",
  bestScoreAcrossAttemptsInfo:
    "Indică cel mai bun scor obținut în mai multe încercări.",
  successfullyRemovedUser: "A fost eliminat cu succes utilizatorul",
  successfullyReinvitedUser: "Utilizatorul a fost reinvitat",
  reinviteTooltip:
    "Reinvitați participanții care nu au început încă evaluarea în curs",
  reInvite: "Reinvitați",
  noParticipantsInvitedYet: "Niciun participant nu a fost invitat încă",
  scheduleExpired: "Programul a expirat",
  assessmentIsOngoing: "Evaluarea este în curs de desfășurare",
  assessmentCompleted: "Evaluare finalizată",
  resultNotProcessed: "Rezultatul nu a fost procesat",
  assessmentNotStarted: "Evaluarea nu a început",
  remove: "Elimina",
  confirmReInvitation: "Confirmați re-invitația",
  confirmReinviteMessage:
    "Sigur doriți să reinviți participanții care nu au început încă evaluarea în curs?",
  removeUserWithNamePrompt: "Sigur doriți să eliminați „{{name}}”?",
  groupType: "Tip de grup",
  objectiveGroupType: "Obiectiv",
  codingGroupType: "Codificarea",
  subjectiveTextSpeakingGroupType: "Subiectiv (text / vorbire)",
  groupTypeImmutableInfo:
    "Tipul grupului nu poate fi modificat ulterior. Pot fi adăugate doar întrebări de acest tip.",
  sameMarkGroupingTitle:
    "Întrebările pot fi grupate numai dacă au aceeași valoare a punctajului",
  sameMarkGroupingDescription:
    "Amestecarea valorilor notelor (de exemplu, 2 puncte și 5 puncte) într-un grup poate duce la scoruri diferite ale secțiunilor atunci când sunt selectate doar unele întrebări. Grupați întrebări similare cu punctaj pentru a menține scorurile consistente.",
  searchQuestion: "Întrebare de căutare",
  addAllSelectedQuestions: "Adăugați toate {{count}} întrebările selectate",
  singleQuestionSelectedCount: "{{count}} întrebare selectată",
  allQuestionsSelectedCount: "Toate cele {{count}} întrebări selectate",
  selectedCountOfTotalQuestions:
    "Selectate {{selected}} din {{total}} {{label}}",
  addSelectedQuestion: "Adăugați întrebarea selectată",
  validationErrors: "Erori de validare",
  failedToAddToGroup: "Nu s-a putut adăuga la grup",
  questionsAddedSuccessfullyWithCount: "{{count}} întrebări adăugate cu succes",
  successfullyUpdatedAssessment: "Evaluarea a fost actualizată cu succes",
  editCustomTnc: "Editează termenii și condițiile personalizate",
  addCustomTnc: "Adaugă termeni și condiții personalizate",
  attributes: "Atribute",
  added: "Adăugate",
  addAttributes: "Adaugă atribute",
  clickHereToAddEditAttributes: "Click aici pentru a adăuga sau edita atribute",
  clickHereToAddAttributes: "Click aici pentru a adăuga atribute",
  addTncAndSave: "Adaugă termenii și condițiile și salvează",
  savedWithFollowingErrors: "Salvat cu următoarele erori",
  selectDomain: "Selectează domeniul",
  selectRegion: "Selectează regiunea",
  selectUsage: "Selectează utilizarea",
  selectCategoryFirst: "Selectează mai întâi categoria",
  selectSubCategory: "Selectează subcategoria",
  addAttributesAndSave: "Adaugă atributele și salvează",
  questionPaperTimer: "Temporizator chestionar",
  sectionLevelTimer: "Temporizator la nivel de secțiune",
  questionLevelTimer: "Temporizator la nivel de întrebare",
  loginWindowDescription:
    "Candidații se pot înscrie doar într-un interval de timp limitat după ora de începere.",
  durationBasedDescription:
    "Ora de încheiere este calculată automat din ora de începere + durata testului.",
  deadlineDescription:
    "Oră de începere și de încheiere fixă; candidații trebuie să termine înainte de termenul limită.",
  loginWindowInfo:
    "Fereastra de conectare este timpul (în minute) în care candidații pot începe evaluarea după ora de începere programată. Odată ce fereastra de conectare se închide, niciun candidat nou nu mai poate intra. Fereastra de conectare trebuie să fie mai mică sau egală cu durata testului.",
  assessmentDurationInfo:
    "Setați doar ora de începere. Sistemul va calcula automat ora de încheiere prin adăugarea duratei testului.",
  startTimeMinAheadInfo:
    "Ora de începere trebuie să fie cu cel puțin 15 minute mai mare decât ora curentă.",
  loginWindowExample:
    "Exemplu: Dacă ora de începere este 9:00 AM și fereastra de conectare este de 30 de minute, candidații pot începe între 9:00 și 9:30 AM, cu o marjă suplimentară de 5 minute.",
  assessmentDurationExample:
    "Exemplu: Dacă ora de începere este 9:00 AM și durata testului este de 60 de minute, evaluarea se va încheia la 10:00 AM, cu o marjă suplimentară de 5 minute.",
  freeFlow: "Navigare liberă",
  oneByOne: "Una câte una",
  subjectiveNoResultInfo: "Informații subiective pentru 'Fără rezultat'",
  candidateResultVisibility: "Vizibilitatea rezultatelor pentru candidat",
  noResult: "Fără rezultat",
  passPercentageRangeError: "Eroare de interval pentru procentul de promovare",
  attemptsAllowedInfo: "Informații despre încercările permise",
  maxAttemptsError: "Eroare: S-a depășit numărul maxim de încercări",
  maximumAttemptsInfo: "Informații despre numărul maxim de încercări",
  limitedAttempts: "Încercări limitate",
  coolOffDescription: "Descrierea perioadei de pauză (cool-off)",
  noCoolOffPeriod: "Fără perioadă de pauză",
  waitFor: "Așteaptă",
  hours: "Ore",
  days: "Zile",
  whatLearnersWillSee: "Ce vor vedea cursanții",
  unlimitedAttemptsInfo:
    "Aveți un număr nelimitat de încercări disponibile pentru această evaluare.",
  waitBeforeNextAttemptPrefix: "După fiecare încercare, va trebui să așteptați",
  waitBeforeNextAttemptSuffix: "înainte de a începe următoarea încercare.",
  waitBeforeNextAttempt:
    "După fiecare încercare, va trebui să așteptați {duration} înainte de a începe următoarea încercare.",
  singleAttemptInfo: "Aveți 1 încercare disponibilă pentru această evaluare.",
  remainingAttemptsInfoPrefix: "Aveți",
  remainingAttemptsInfoMiddle: "din",
  remainingAttemptsInfoSuffix: "încercări disponibile pentru această evaluare.",
  remainingAttemptsInfo:
    "Aveți {remaining} din {total} încercări disponibile pentru această evaluare.",
  enableCertificate: "Activează certificatul",
  enableCertificateDescription:
    "Emiteți un certificat candidaților după finalizarea cu succes a evaluării.",
  maxAllowed100: "Maxim permis 100",
  scheduleAssessment: "Programează evaluarea",
  privateAssessmentLabel: "Evaluare privată",
  publicAssessmentLabel: "Evaluare publică",
  privateAssessmentDescription:
    "Această evaluare este doar pe bază de invitație și este disponibilă strict în intervalul definit de început și sfârșit.",
  publicAssessmentDescription:
    "Această evaluare acceptă atât acces auto-atribuit, cât și acces pe bază de invitație, fără un interval fix de acces.",
  schedulePublicAssessment: "Programează evaluarea publică",
  successfullyPublishedAssessment: "Evaluarea a fost publicată cu succes",
  publishWithoutProctoringPrompt: "Publicați fără supraveghere (proctoring)?",
  publishAssessmentPrompt: "Publicați evaluarea?",
  sectionScoreAnalysis: "Analiza scorului pe secțiuni",
  sectionScoreAnalysisOverview:
    "Prezentare generală a analizei scorului pe secțiuni",
  section: "Secțiune",
  noSectionDataAvailable: "Nu există date disponibile pentru această secțiune",
  difficultyLevelAnalysis: "Analiza nivelului de dificultate",
  browserViolations: "Încălcări ale regulilor browserului",
  videoViolations: "Încălcări video",
  times: "Ori",
  statusMessageUnavailable: "Mesaj de stare indisponibil",
  viewViolationEvidence: "Vizualizează dovezile încălcării",
  noBrowserViolationsDetected:
    "Nu s-au detectat încălcări ale regulilor browserului",
  noVideoViolationsDetected: "Nu s-au detectat încălcări video",
  candidateNotAttemptedCodingMessage:
    "Mesaj: Candidatul nu a încercat exercițiul de programare",
  candidateCode: "Codul candidatului",
  candidateScore: "Scorul candidatului",
  compilationCount: "Număr de compilări",
  submissionCount: "Număr de trimiteri",
  timeTaken: "Timp acordat",
  testCaseReport: "Raport cazuri de testare",
  performanceAndCompilationMetrics: "Metrici de performanță și compilare",
  totalTestCases: "Total cazuri de testare",
  testCasesPassed: "Cazuri de testare trecute",
  testCaseDetails: "Detalii caz de testare",
  searchQuestions: "Caută întrebări",
  clearSearch: "Șterge căutarea",
  question: "întrebare",
  isSelected: "este selectat",
  areSelected: "sunt selectate",
  selected: "Selectat",
  questionsPerPage: "Întrebări pe pagină:",
  publishQuestions: "Publică întrebările",
  send: "Trimite",
  move: "Mută",
  publishQuestionsConfirmation:
    "Sigur doriți să publicați {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Sigur doriți să trimiteți {{count}} {{label}} pentru revizuire?",
  moveToDraftConfirmation:
    "Sigur doriți să mutați {{count}} {{label}} în schițe?",
  bulkPublishDisclaimer:
    "Vă rugăm să verificați dacă toate întrebările selectate sunt complete, corecte și afișate conform intenției înainte de a le publica.",
  bulkReviewDisclaimer:
    "Vă rugăm să verificați dacă toate întrebările selectate sunt complete, corecte și afișate conform intenției înainte de a les trimite pentru revizuire.",
  bulkDraftDisclaimer:
    "Vă rugăm să verificați dacă toate întrebările selectate sunt complete, corecte și afișate conform intenției înainte de a le muta în schițe.",
  questionsUnderProcess:
    "Întrebările sunt în curs de procesare, vă rugăm să faceți clic pe 'vezi detalii' pentru a verifica starea întrebărilor.",
  mixedStatusesSelected: "Statusuri mixte selectate",
  mixedStatusesWarning:
    "Vă rugăm să vă asigurați că toate întrebările selectate au același status înainte de a continua.",
  selectionLimitReached: "Limită de selecție atinsă",
  selectionLimitWarning:
    "Nu puteți selecta mai mult de {{count}} întrebări pentru o acțiune în masă. Deselectați o întrebare înainte de a selecta alta.",
  knowMore: "Află mai multe",
  guideLearnersRightDepth:
    "Ghidați-vă cursanții cu întrebări care se potrivesc nivelului corect de profunzime.",
  bloomCreateDescription:
    "Evaluează capacitatea cursantului de a proiecta, arhitectura sau construi noi sisteme ori soluții de cod folosind multiple concepte.",
  bloomEvaluateDescription:
    "Verifică dacă cursantul poate evalua critic codul, justifica alegerile sau evalua diferite soluții.",
  bloomAnalyzeDescription:
    "Testează capacitatea cursantului de a descompune codul, de a face depanare (debug), de a urmări logica sau de a identifica tipare în sistemele tehnice.",
  bloomApplyDescription:
    "Evaluează dacă cursantul poate aplica concepte pentru a rezolva probleme practice de codare sau scenarii din lumea reală.",
  bloomUnderstandDescription:
    "Verifică dacă cursantul poate înțelege și explica concepte în propriile cuvinte sau interpreta comportamentul unui sistem.",
  bloomRememberDescription:
    "Evaluează capacitatea cursantului de a-și aminti definiții de bază, sintaxă și informații factuale.",
  bloomVerbCreate: "Creează",
  bloomVerbDesign: "Proiectează",
  bloomVerbConstruct: "Construiește",
  bloomVerbDevelop: "Dezvoltă",
  bloomVerbEvaluate: "Evaluează",
  bloomVerbJustify: "Justifică",
  bloomVerbDefend: "Apără",
  bloomVerbAssess: "Estimează",
  bloomVerbAnalyze: "Analizează",
  bloomVerbDifferentiate: "Diferențiază",
  bloomVerbOrganize: "Organizează",
  bloomVerbCompare: "Compară",
  bloomVerbApply: "Aplică",
  bloomVerbUse: "Utilizează",
  bloomVerbDemonstrate: "Demonstrează",
  bloomVerbSolve: "Rezolvă",
  bloomVerbExplain: "Explică",
  bloomVerbDescribe: "Descrie",
  bloomVerbSummarize: "Rezumă",
  bloomVerbInterpret: "Interpretează",
  bloomVerbList: "Listează",
  bloomVerbDefine: "Definește",
  bloomVerbName: "Numește",
  bloomVerbRecall: "Reamintește-ți",
  bloomVerbRecognize: "Recunoaște",
  bloomCreateExample1:
    "Creează o aplicație de tip single-page folosind React și Redux.",
  bloomCreateExample2:
    "Proiectează o schemă pentru baza de date a unei aplicații de ridesharing.",
  bloomCreateExample3: "Dezvoltă un flux CI/CD folosind GitHub Actions.",
  bloomEvaluateExample1:
    "Evaluează avantajele și dezavantajele utilizării NoSQL în detrimentul SQL într-o arhitectură de microservicii.",
  bloomEvaluateExample2:
    "Recomandă îmbunătățiri pentru a optimiza performanța componentei React.",
  bloomAnalyzeExample1:
    "Compară performanța algoritmilor merge sort și quicksort.",
  bloomAnalyzeExample2:
    "Analizează utilizarea memoriei pentru această funcție recursivă.",
  bloomAnalyzeExample3:
    "Categorisește erorile din acest bloc de cod JavaScript.",
  bloomApplyExample1:
    "Aplică algoritmul de căutare binară pentru a găsi un element într-un tablou (array).",
  bloomApplyExample2:
    "Utilizează o buclă pentru a afișa șirul lui Fibonacci în Python.",
  bloomApplyExample3:
    "Rezolvă o problemă din lumea reală folosind un hash map.",
  bloomUnderstandExample1:
    "Explică cum funcționează o stivă folosind principiul LIFO.",
  bloomUnderstandExample2:
    "Descrie diferența dintre var, let și const în JavaScript.",
  bloomUnderstandExample3: "Interpretează rezultatul interogării SQL date.",
  bloomRememberExample1:
    "Identifică eticheta (tag-ul) HTML corectă pentru a crea un hyperlink.",
  bloomRememberExample2:
    "Numește cei patru piloni ai Programării Orientate pe Obiecte (POO).",
  bloomRememberExample3: "Listează tipurile de date primitive în Java.",
  commonVerbs: "Verbe comune",
  exampleQuestions: "Întrebări exemplu",
  noExamplesAvailable: "Niciun exemplu disponibil.",
  candidateResponse: "Răspunsul candidatului",
  correctQuestions: "Întrebări corecte",
  totalQuestions: "Total întrebări",
  correctQuestionPercentage: "Procent întrebări corecte",
  performance: "Performanță",
  level: "NIVEL",
  noOfQuestions: "NUMĂR DE ÎNTREBĂRI",
  correctAttempts: "ÎNCERCĂRI CORECTE",
  correctness: "CORECTITUDINE",
  partiallyCorrect: "PARȚIAL CORECT",
  partiallyCorrectPercentage: "PROCENT PARȚIAL CORECT",
  rescheduleAssessmentPrompt:
    "Vă rugăm să confirmați dacă doriți să reprogramați evaluarea cu titlul „{{title}}”",
  assessmentAlreadyStarted: "Evaluarea a început deja",
  readMore: "Citește mai mult",
  best: "Cele mai bune",
  latest: "Cele mai recente",
  allQuestions: "Toate întrebările",
  myQuestions: "Întrebările mele",
  publicQuestions: "Întrebările publice",
  remarks: "Observații",
  addRemarks: "Adaugă observații",
  noGroupsAdded: "Nu a fost adăugat niciun grup încă",
  addGroupInfo:
    "Începeți prin a crea un grup pentru a adăuga întrebări. Faceți clic pe butonul „Adaugă grupul la secțiune” de mai jos pentru a începe.",
  exitPreview: "Ieși din previzualizare",
  preview: "Previzualizare",
  problemStatementNotAdded: "Descrierea problemei nu a fost adăugată",
  durationDayUnit: "zi",
  durationDaysUnit: "zile",
  durationHourUnit: "oră",
  durationHoursUnit: "ore",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Câmpul personalizat {{fieldLabel}} a fost adăugat pentru {{current}} din {{total}} limbă",
  customFieldAddedForMultipleLanguages:
    "Câmpul personalizat {{fieldLabel}} a fost adăugat pentru {{current}} din {{total}} limbi",
  email: "E-Mail",
  tagInputHint: "Adăugați separate prin virgulă",
  enterOptions: "Introduceți opțiuni",
  groupNotFound: "Grupul nu a fost găsit",
  sheetNotFound: "Foaia nu a fost găsită",
  missingHeaders: "Lipsesc anteturile necesare",
  assetNotFound: "Resursa nu a fost găsită",
  noValidDataFound: "Nu au fost găsite date valide",
  notFoundPID: "Participantul nu a fost găsit.",
  invalidParticipants: "Participant nevalid.",
  alreadyAdded: "Participantul a fost deja adăugat.",
  duplicateData: "Au fost găsite date duplicate.",
  invalidData: "Date nevalide.",
  warnings: "Avertismente",
  assignedToMyself: "Atribuit mie (Învățare Independentă)",
  assignedByMe: "Atribuit de mine (Sarcinile Mele)",
  urlCopiedToClipboard: "URL copiat în clipboard!",
  failedToCopyUrl: "Eroare la copiere URL.",
  content: "Conținut",
  platformHelp: "Ajutor platformă",
  privacyPolicy: "Politica de confidențialitate",
  logout: "Deconectare",
  logoutConfirmTitle: "Sigur doriți să vă deconectați?",
  logoutConfirmDescription:
    "Pleci? Te poți întoarce oricând și continua de unde ai rămas.",
  stayEngaged: "Rămâi implicat"
} as const;
export default ro;
